import {
  _Dimension___get_value__impl__urhqzr1mx919605mj8b as _Dimension___get_value__impl__urhqzr,
  times2ukvaf6yk96p2 as times,
  get_entries3nqgftw5r4i02 as get_entries,
  Dimensions32ju1l7z4mh as Dimension,
  Dimension__toString_impl_o4q1adx82fzjdnbyok as Dimension__toString_impl_o4q1ad,
} from '../models/data.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  toRawCornerRadius2lzu7hpq9jr9l as toRawCornerRadius,
  Companion_getInstance1pd09epsgyyke as Companion_getInstance,
} from '../models/data.commonHtml.mjs';
import { DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import {
  Duration__toDouble_impl_a56y2bbonx5x15fky2 as Duration__toDouble_impl_a56y2b,
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_0,
  toDuration7gy6v749ektt as toDuration,
  Duration5ynfiptaqcrg as Duration,
  Duration__plus_impl_yu9v8f2gb5hwgakp0dd as Duration__plus_impl_yu9v8f,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  asSequence2phdjljfh9jhx as asSequence,
  plus310ted5e4i90h as plus,
  getOrNull1go7ef9ldk0df as getOrNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  listOf1jh22dvmctj1r as listOf,
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import {
  HoverSemantic_getInstance2nvjr5vpt4xe8 as HoverSemantic_getInstance,
  FocusSemantic_getInstance2hulmpskh8zvf as FocusSemantic_getInstance,
  DownSemantic_getInstance12o2om5g6786l as DownSemantic_getInstance,
  DisabledSemantic_getInstanceimdypc22j9b3 as DisabledSemantic_getInstance,
  PrintSemantic_getInstance88ipr19ayg2g as PrintSemantic_getInstance,
  SelectedSemantic_getInstance3ef29ujazc52t as SelectedSemantic_getInstance,
  UnselectedSemantic_getInstancexnnq5hq6ryv2 as UnselectedSemantic_getInstance,
} from '../models/Theme.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { asSequence2jzw5xbq99nu9 as asSequence_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import {
  mapsbvh18eqox7a as map,
  flatMapgxtanzi5fvh9 as flatMap,
  joinToStringooja5rkatz3u as joinToString_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { roundToInt1ue8x8yshtznx as roundToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { printStackTrace18lnx7a39cni as printStackTrace } from '../../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { listOfvhqybd2zx248 as listOf_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { trimIndent1qytc1wvt8suh as trimIndent } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Indent.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  Monotonic_instance6v32gqtywf7e as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs1dlqois04h852 as ValueTimeMark__elapsedNow_impl_eonqvs,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/TimeSource.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  FadingColor3d6ef6zcqmlhk as FadingColor,
  RadialGradient3ic79yys0k1fp as RadialGradient,
  LinearGradient2qftccjwl6uey as LinearGradient,
  Color17ck47lkedxoy as Color,
} from '../models/Paint.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Companion_getInstanceeghlbkcb6su6 as Companion_getInstance_1,
  _Angle___get_turns__impl__atdtw5dv920nekm6fo as _Angle___get_turns__impl__atdtw5,
  _Angle___init__impl__g23q1mpxbjdjfwrarw as _Angle___init__impl__g23q1m,
} from '../models/Angle.mjs';
import { maxOfnpw4mt1rg0hl as maxOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/_ComparisonsJs.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/rangeTo.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toBoxShadow($this, _this__u8e3s4) {
  if (_Dimension___get_value__impl__urhqzr(_this__u8e3s4).oax() === 0.0)
    return 'none';
  var offsetX = _Dimension___get_value__impl__urhqzr(get_px(0));
  var offsetY = _Dimension___get_value__impl__urhqzr(_this__u8e3s4);
  var blur = _Dimension___get_value__impl__urhqzr(times(_this__u8e3s4, 2));
  var spread = _Dimension___get_value__impl__urhqzr(get_px(0));
  return offsetX.toString() + ' ' + offsetY.toString() + ' ' + blur.toString() + ' ' + spread.toString() + ' #00000099';
}
function toCss($this, _this__u8e3s4) {
  return Duration__toDouble_impl_a56y2b(_this__u8e3s4, DurationUnit_SECONDS_getInstance()).toString() + 's';
}
function joinGradientStops($this, stops) {
  return joinToString(stops, VOID, VOID, VOID, VOID, VOID, KiteUiCss$joinGradientStops$lambda);
}
function _get_classes__of2uz9($this, _this__u8e3s4) {
  return 't-' + _this__u8e3s4.db0_1;
}
function _get_classSelector__lhiabq($this, _this__u8e3s4) {
  return '.' + _get_classes__of2uz9($this, _this__u8e3s4);
}
function transition$extracted(_this__u8e3s4, part) {
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = part.cay_1.d2().m1();
  while (_iterator__ex2g4s.n1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.o1();
    // Inline function 'kotlin.collections.component1' call
    var key = _destruct__k2r9zo.e2();
    // Inline function 'kotlin.collections.component2' call
    var value = _destruct__k2r9zo.f2();
    _this__u8e3s4.wb(key + ': ' + value + '; ');
  }
  _this__u8e3s4.wb('} to { ');
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_0 = part.day_1.d2().m1();
  while (_iterator__ex2g4s_0.n1()) {
    var _destruct__k2r9zo_0 = _iterator__ex2g4s_0.o1();
    // Inline function 'kotlin.collections.component1' call
    var key_0 = _destruct__k2r9zo_0.e2();
    // Inline function 'kotlin.collections.component2' call
    var value_0 = _destruct__k2r9zo_0.f2();
    _this__u8e3s4.wb(key_0 + ': ' + value_0 + '; ');
  }
  _this__u8e3s4.wb('}');
}
function themeInteractive$_anonymous_$sub_69hfgi($theme, this$0, cs, subthemeGen, asSelectors) {
  var tmp;
  if (subthemeGen == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = $theme.db1(subthemeGen);
  }
  var tmp1_elvis_lhs = tmp;
  var subtheme = tmp1_elvis_lhs == null ? $theme.ab1_1 : tmp1_elvis_lhs;
  if (!$theme.equals(subtheme.eb1_1)) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = asSelectors.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var list = listOf([element + ' ' + cs, element + cs]);
      addAll(destination, list);
    }
    this$0.mb1(subtheme.eb1_1, $theme, destination, subtheme.fb1_1);
  }
  var hov = subtheme.db1(HoverSemantic_getInstance());
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_0 = ArrayList().w();
  var _iterator__ex2g4s_0 = asSelectors.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    var list_0 = listOf(['.clickable:hover' + element_0 + ' ' + cs, '.clickable:hover' + element_0 + cs]);
    addAll(destination_0, list_0);
  }
  this$0.nb1(hov.eb1_1, $theme, destination_0, hov.fb1_1, '(hover : hover)');
  var foc = subtheme.db1(FocusSemantic_getInstance());
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_1 = ArrayList().w();
  var _iterator__ex2g4s_1 = asSelectors.m1();
  while (_iterator__ex2g4s_1.n1()) {
    var element_1 = _iterator__ex2g4s_1.o1();
    var list_1 = listOf(['.clickable:focus-visible' + element_1 + ' ' + cs, '.clickable:focus-visible' + element_1 + cs, 'input:focus' + element_1 + cs, 'textarea:focus' + element_1 + cs, 'select:focus' + element_1 + cs, '.hasNoBackField:focus-within' + element_1 + cs]);
    addAll(destination_1, list_1);
  }
  this$0.mb1(foc.eb1_1, $theme, destination_1, foc.fb1_1);
  var dwn = subtheme.db1(DownSemantic_getInstance());
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_2 = ArrayList().w();
  var _iterator__ex2g4s_2 = asSelectors.m1();
  while (_iterator__ex2g4s_2.n1()) {
    var element_2 = _iterator__ex2g4s_2.o1();
    var list_2 = listOf(['.clickable:active' + element_2 + ' ' + cs, '.clickable:active' + element_2 + cs]);
    addAll(destination_2, list_2);
  }
  this$0.mb1(dwn.eb1_1, $theme, destination_2, dwn.fb1_1);
  var dis = subtheme.db1(DisabledSemantic_getInstance());
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_3 = ArrayList().w();
  var _iterator__ex2g4s_3 = asSelectors.m1();
  while (_iterator__ex2g4s_3.n1()) {
    var element_3 = _iterator__ex2g4s_3.o1();
    var list_3 = listOf(['.clickable:disabled' + element_3 + ' ' + cs, '.clickable:disabled' + element_3 + cs]);
    addAll(destination_3, list_3);
  }
  this$0.mb1(dis.eb1_1, $theme, destination_3, dis.fb1_1);
  var print = subtheme.db1(PrintSemantic_getInstance());
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_4 = ArrayList().u(collectionSizeOrDefault(asSelectors, 10));
  var _iterator__ex2g4s_4 = asSelectors.m1();
  while (_iterator__ex2g4s_4.n1()) {
    var item = _iterator__ex2g4s_4.o1();
    var tmp$ret$17 = item + cs + cs;
    destination_4.v(tmp$ret$17);
  }
  this$0.nb1(print.eb1_1, $theme, destination_4, print.fb1_1, 'print');
}
function theme$sel($asSelectors, plus) {
  var tmp = asSequence($asSelectors);
  return joinToString_0(flatMap(tmp, (it) => {
    var tmp = asSequence_0(plus);
    return map(tmp, (p) => '' + it + p);
  }), ', ');
}
function theme$addToCss(this$0, $mediaQuery, selector, key, value) {
  this$0.hb1_1.vb1(selector, key, value, $mediaQuery);
}
function KiteUiCss$lambda(it) {
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  return it.a4_1.toLowerCase();
}
function KiteUiCss$joinGradientStops$lambda(it) {
  return it.gaz_1.paz() + ' ' + it.faz_1 * 100 + '%';
}
function KiteUiCss$rowCollapsingToColumn$lambda(it) {
  return roundToInt(_Dimension___get_value__impl__urhqzr(it.wb1_1).oax()).toString();
}
var KiteUiCssClass;
function KiteUiCss() {
  if (KiteUiCssClass === VOID) {
    class $ {
      constructor(dynamicCss) {
        this.hb1_1 = dynamicCss;
        try {
          this.hb1_1.xb1('@media print {\n    .do-not-print{\n        display: none !important;\n    }\n    .scroll-vertical {\n        overflow: hidden auto;\n    }\n    body > div {\n        height: unset;\n        max-width: 100vw;\n    }\n\n    body {\n        height: unset;\n        max-height: unset;\n        max-width: 100vw;\n        overflow: visible;\n    }\n    .kiteui-col > * {\n        flex-grow: 0 !important;\n        flex-shrink: 0 !important;\n        flex-basis: unset !important;\n    }\n}');
        } catch ($p) {
          if ($p instanceof Exception()) {
            var e = $p;
            printStackTrace(Exception().vd('Failed to add print ruleset', e));
          } else {
            throw $p;
          }
        }
        this.hb1_1.xb1(' /*noinspection ALL*/@media {\n .kui {\n     margin: 0;\n     padding: 0;\n     border: 0;\n     font-size: 100%;\n     font: inherit;\n     vertical-align: baseline;\n }\n \n p.kui, h1.kui, h2.kui, h3.kui, h4.kui, h5.kui, h6.kui, .subtext {\n     white-space: pre-wrap;\n }\n \n p.kui li.kui {\n     margin-inline-start: 1em;\n }\n p.kui a.kui {\n     text-decoration: revert;\n     color: revert;\n }\n p.kui a.kui:visited {\n     color: revert;\n }\n\n /* HTML5 display-role reset for older browsers */\n article.kui, aside.kui, details.kui, figcaption.kui, figure.kui, footer.kui, header.kui, hgroup.kui, menu.kui, nav.kui, section.kui {\n     display: block;\n }\n\n body {\n     line-height: 1;\n }\n\n ol.kui, ul.kui {\n     list-style: none;\n }\n\n blockquote.kui, q.kui {\n     quotes: none;\n }\n\n blockquote.kui:before, blockquote.kui:after, q.kui:before, q.kui:after {\n     content: \'\';\n     content: none;\n }\n\n table.kui {\n     border-collapse: collapse;\n     border-spacing: 0;\n }\n\n .kui.icon {\n     color: var(--icon-color, black);\n }\n\n .kui.padded:not(.swapImage) {\n     padding: var(--padding, 0px);\n }\n\n input.kui[type="number"] {\n     appearance: textfield;\n }\n\n input.kui::-webkit-outer-spin-button, input::-webkit-inner-spin-button {\n     appearance: none;\n }\n\n progress.kui::-moz-progress-bar {\n     height: 100%;\n     background-color: currentcolor;\n     border-radius: 1rem;\n }\n\n progress.kui::-webkit-progress-bar {\n     border-radius: 100px;\n }\n\n progress.kui::-webkit-progress-value {\n     height: 100%;\n     background-color: currentcolor;\n     border-radius: 1rem;\n }\n\n progress.kui {\n     background: none;\n     max-height: 0.25rem !important;\n     border: medium;\n     border-radius: 1rem;\n     padding: 0px !important;\n     appearance: none;\n }\n \n \n \n.kui.progress-ring {\n   width: 100%;\n   justify-content: space-around;\n }\n \n .kui.progress-ring-svg {\n     display: block;\n     margin: 10px auto;\n }\n\n .circle-progress-background {\n               fill: none;\n               stroke: var(--nearest-background-color); !important;\n               stroke-width: 3;\n }\n \n .circle-progress {\n     fill: none;\n     stroke-width:2.8;\n     stroke-linecap: round;\n     animation: progress 1s ease-out forwards;\n       stroke: currentcolor;\n }\n\n @media (pointer: coarse) and (hover: none) {\n     .touchscreenOnly {\n         visibility: visible;\n     }\n }\n \n * {\n     gap: var(--spacing, 0);\n }       \n\n .kui.touchscreenOnly {\n }\n .kui.disableContextMenu {\n     -webkit-user-select: none !important;  \n     -webkit-touch-callout: none !important;  \n }\n\n .kui.viewPager > :not(.recyclerViewCap) {\n     width: var(--pager-width, 0rem);\n     height: var(--pager-height, 0rem);\n     scroll-snap-align: center;\n     scroll-snap-stop: always;\n }\n\n .kui.viewPager {\n     scroll-snap-type: x mandatory;\n }\n\n .kui.hideScrollbar {\n     scrollbar-width: none;\n }\n .kui.hideScrollbar::-webkit-scrollbar {\n     display: none;\n }\n\n .kui.suppress-overflow-anchors > * {\n     overflow-anchor: none;\n }\n\n .kui.notransition, .kui.notransition * {\n     transition: none !important;\n }\n\n .kui.animatingShowHide {\n     overflow: hidden;\n }\n\n .kui {\n     box-sizing: border-box;\n     line-height: unset;\n     --parentPadding: 0px;\n     scrollbar-color: rgb(153, 153, 153) rgba(0, 0, 0, 0);\n     scrollbar-width: thin;\n     scrollbar-gutter: auto;\n     flex-shrink: 0;\n     max-width: calc(100%);\n     max-height: calc(100%);\n     min-height: 0px;\n     min-width: 0px;\n     padding: 0px;\n     transition-timing-function: linear;\n     transition-delay: 0s;\n     transition-property: color, background-image, background-color, border-color, outline-color, outline-width, box-shadow, border-radius, opacity, backdrop-filter, transform;\n }\n \n .kui.transition {\n     overflow: hidden;\n }\n\n .kui[hidden] {\n     display: none !important;\n }\n\n @keyframes spin {\n     0% {\n         transform: rotate(0deg);\n     }\n     100% {\n         transform: rotate(360deg);\n     }\n }\n\n @keyframes flickerAnimation {\n     0% {\n         opacity: 1;\n     }\n     50% {\n         opacity: 0.5;\n     }\n     100% {\n         opacity: 1;\n     }\n }\n\n .kui::-webkit-scrollbar-corner {\n     background: none;\n }\n\n .kui::-webkit-scrollbar-thumb {\n     background: color-mix(in srgb, currentcolor 20%, transparent);\n     border-radius: 4px;\n }\n\n .kui::-webkit-scrollbar {\n     background: none;\n }\n\n .kui.scroll-horizontal {\n     overflow: auto hidden;\n }\n\n .kui.scroll-horizontal  * {\n     max-width: unset;\n }\n .kui.scroll-horizontal * {\n     max-width: 100;\n }\n\n .kui.scroll-vertical {\n     overflow: hidden auto;\n }\n\n .kui.scroll-vertical  * {\n     max-height: unset;\n }\n .kui.has-set-height * {\n     max-height: 100%;\n }\n\n iframe#webpack-dev-server-client-overlay {\n     display: none !important;\n }\n\n .kui.kiteui-separator {\n     background-color: var(--separator-color, currentcolor);\n     min-width: 1px;\n     min-height: 1px;\n }\n\n .kui::placeholder {\n     color: currentcolor;\n     opacity: 0.3;\n }\n\n .kiteui-label.kiteui-label {\n     display: flex;\n     flex-direction: column;\n     align-items: stretch;\n }\n\n .crowd {\n     padding: 0px !important;\n }\n\n :checked.radio::after {\n     opacity: 1;\n     transform: none;\n }\n\n .radio::after {\n     position: absolute;\n     border-radius: 999px;\n     content: "";\n     display: block;\n     width: 50%;\n     height: 50%;\n     top: 25%;\n     left: 25%;\n     background-color: currentcolor;\n     opacity: 0.4;\n     transform: scale(0);\n     transition-property: opacity, transform;\n     transition-timing-function: linear;\n     transition-duration: var(--transition-duration, 0.25s);\n }\n\n .radio.radio.radio {\n     appearance: none;\n     width: 25px !important;\n     height: 25px !important;\n     position: relative;\n     border-radius: 999px !important;\n     padding: 0px !important;\n     border-width: 0.1rem;\n     border-style: solid;\n     outline: none;\n     border-color: var(--icon-color, currentcolor);\n }\n\n :checked.checkbox::after {\n     opacity: 1;\n     transform: rotate(-45deg);\n }\n\n .checkbox::after {\n     position: absolute;\n     content: "";\n     display: block;\n     width: 50%;\n     height: 20%;\n     top: 25%;\n     left: 20%;\n     border-color: currentcolor;\n     border-left-style: solid;\n     border-left-width: 0.2rem;\n     border-bottom-width: 0.2rem;\n     border-bottom-style: solid;\n     opacity: 0.4;\n     transform: rotate(-45deg) scale(0);\n     transition-property: opacity, transform;\n     transition-timing-function: linear;\n     transition-duration: var(--transition-duration, 0.25s);\n }\n\n .checkbox:checked {\n     opacity: 1;\n }\n\n .checkbox.checkbox.checkbox {\n     appearance: none;\n     width: 25px !important;\n     height: 25px !important;\n     position: relative;\n     padding: 0px !important;\n     border-width: 0.1rem;\n     border-style: solid;\n     border-color: var(--icon-color, currentcolor);\n     border-radius: 20%;\n     outline: none;\n     opacity: 0.75;\n }\n\n .switch:checked::before {\n     left: calc(1.4rem);\n }\n\n .switch::before {\n     position: absolute;\n     content: "";\n     left: calc(-0.1rem);\n     top: calc(-0.1rem);\n     display: block;\n     height: 1.6rem;\n     width: 1.6rem;\n     max-width: unset;\n     max-height: unset;\n     cursor: pointer;\n     border: 1px solid rgba(100, 116, 139, 0.527);\n     border-radius: 9999px !important;\n     background-color: rgb(255, 255, 255);\n     box-shadow: rgba(100, 116, 139, 0.327) 0px 3px 10px;\n     transition: 0.3s;\n }\n\n .switch:checked {\n     background-color: #20a020 !important;\n }\n\n .switch {\n     position: relative;\n     overflow: visible;\n     padding: 0px !important;\n     height: 1.5rem !important;\n     width: 3rem !important;\n     cursor: pointer;\n     appearance: none;\n     border-radius: 9999px !important;\n     background-color: color-mix(in srgb, currentcolor 20%, transparent) !important;\n     background-image: none !important;\n     transition: 0.3s;\n }\n\n .clickable {\n     cursor: pointer;\n }\n\n button.kui {\n     position: relative;\n }\n\n button.kui.working::after {\n     opacity: 0.5 !important;\n     content: "";\n     pointer-events: none;\n     position: absolute;\n     top: calc(50% - 15px);\n     left: calc(50% - 15px);\n     width: 20px !important;\n     height: 20px !important;\n     background: none !important;\n     box-shadow: none !important;\n     border-style: solid !important;\n     border-color: currentcolor currentcolor currentcolor transparent !important;\n     border-width: 6px !important;\n     border-radius: 50% !important;\n     transition: 0.3s;\n     animation: 2s linear infinite spin !important;\n }\n \n .popover {\n     transition-property: color, background-image, background-color, border-color, outline-color, outline-width, box-shadow, border-radius, opacity, backdrop-filter;\n }\n\n img.kui {\n     overflow: hidden;\n }\n \n .optimized > * {\n     display: block;\n }\n .weakFill {\n     width: 100%;\n     height: 100%;\n }\n\n .spinner {\n     display: block;\n     width: 32px !important;\n     height: 32px !important;\n     opacity: 0.5;\n     background: none !important;\n     box-shadow: none !important;\n     border-style: solid !important;\n     border-color: currentcolor currentcolor currentcolor transparent !important;\n     border-width: 5px !important;\n     border-radius: 50% !important;\n     animation: 2s linear infinite spin !important;\n }\n\n input.kui:focus:not(.transition), select.kui:focus:not(.transition), textarea.kui:focus:not(.transition) {\n     outline: none;\n }\n\n button.kui, input.kui, textarea.kui, select.kui {\n     background: none;\n     border-width: 0px;\n     outline-width: 0px;\n     font: unset;\n     color: unset;\n     text-align: start;\n }\n\n a.kui:visited {\n     color: unset;\n }\n\n a.kui {\n     text-decoration: none;\n     color: unset;\n     display: block;\n }\n\n body > div.kui {\n     height: 100%;\n     max-width: 100vw;\n }\n\n body {\n     height: 100svh;\n     max-height: 100svh;\n     max-width: 100vw;\n     overflow: hidden;\n }\n\n .noInteraction.noInteraction {\n     pointer-events: none;\n }\n .noInteraction > * {\n     pointer-events: auto;\n }\n\n video.scaleType-NoScale {\n     object-fit: none;\n }\n\n video.scaleType-Stretch {\n     object-fit: fill;\n }\n\n video.scaleType-Crop {\n     object-fit: cover;\n }\n\n video.scaleType-Fit {\n     object-fit: contain;\n }\n\n img.scaleType-NoScale {\n     object-fit: none;\n }\n\n img.scaleType-Stretch {\n     object-fit: fill;\n }\n\n img.scaleType-Crop {\n     object-fit: cover;\n }\n\n img.scaleType-Fit {\n     object-fit: contain;\n }\n \n .clickable.draggable {\n     cursor: default;\n }\n .draggable {\n     cursor: grab;\n }\n\n .swapImage > img {\n     object-fit: contain;\n     transition-duration: var(--transition-duration, 0.25s);\n   position: absolute;\n     width: 100%;\n   height: 100%;\n }\n .swapImage {\n   position: relative;\n }\n\n .swapImage.loading.useLoading::before {\n     display: block;\n     content: " ";\n     width: 32px !important;\n     height: 32px !important;\n     position: absolute;\n     left: calc(50% - 32px);\n     top: calc(50% - 32px);\n     opacity: 0.5 !important;\n     background: none !important;\n     box-shadow: none !important;\n     border-style: solid !important;\n     border-color: currentcolor currentcolor currentcolor transparent !important;\n     border-width: 5px !important;\n     border-radius: 50% !important;\n     animation: 2s linear infinite spin !important;\n }\n\n .swapImage, .icon {\n     overflow: hidden;\n     line-height: 0px;\n     display: block;\n }\n .icon {\n     border-radius: 0px !important;\n }\n .icon.icon > svg {\n     display: block;\n     max-width: 100%;\n     max-height: 100%;\n }\n \n .textarea-container {\n   /* easy way to plop the elements on top of each other and have them both sized based on the tallest one\'s height */\n   display: grid;\n   position: relative;\n   overflow-y: scroll;\n }\n .textarea-container::after {\n   /* Note the weird space! Needed to preventy jumpy behavior */\n   content: attr(data-replicated-value) " ";\n\n   /* This is how textarea text behaves */\n   white-space: pre-wrap;\n\n   /* Hidden from view, clicks, and screen readers */\n   visibility: hidden;\n   \n   padding: 2px;\n }\n .textarea-container > textarea {\n   /* You could leave this, but after a user resizes, then it ruins the auto sizing */\n   resize: none;\n   position: absolute;\n   left: 0;\n   right: 0;\n   top: 0;\n   bottom: 0;\n }\n .textarea-container > textarea,\n .textarea-container::after {\n   /* Identical styling required!! */\n   font: inherit;\n\n   /* Place on top of each other */\n   grid-area: 1 / 1 / 2 / 2;\n }\n\n .kiteui-space {\n     display: block;\n     min-height: calc(var(--space-multiplier, 1.0) * var(--spacing, 0px));\n     min-width: calc(var(--space-multiplier, 1.0) * var(--spacing, 0px));\n }\n\n .kui:hover.visibleOnParentHover {\n     visibility: visible;\n }\n\n .kui:hover > .visibleOnParentHover {\n     visibility: visible;\n }\n\n .visibleOnParentHover {\n     visibility: hidden;\n     width: auto;\n     height: auto;\n     max-width: unset;\n     max-height: unset;\n }\n\n }');
        var _iterator__ex2g4s = plus(get_entries(), listOf_0(null)).m1();
        while (_iterator__ex2g4s.n1()) {
          var h = _iterator__ex2g4s.o1();
          var _iterator__ex2g4s_0 = plus(get_entries(), listOf_0(null)).m1();
          while (_iterator__ex2g4s_0.n1()) {
            var v = _iterator__ex2g4s_0.o1();
            var tmp = toString(h);
            var tmp_0 = toString(v);
            var tmp_1 = listOfNotNull([h, v]);
            this.hb1_1.xb1(trimIndent('\n                    .kui.snapTo-' + tmp + '-' + tmp_0 + ' > :not(:first-child) {\n                        scroll-snap-align: ' + joinToString(tmp_1, ' ', VOID, VOID, VOID, VOID, KiteUiCss$lambda) + '\n                    }\n                '));
          }
        }
        try {
          this.hb1_1.xb1('progress.kui::-webkit-progress-value {\n                    height: 100%;\n                    background-color: currentColor;\n                    border-radius: 1rem;\n                }');
        } catch ($p) {
          if ($p instanceof Error) {
            var e_0 = $p;
          } else {
            throw $p;
          }
        }
        try {
          this.hb1_1.xb1('progress.kui::-webkit-progress-bar {\n                    border-radius: 100px;\n                    background: var(--nearest-background-color);\n                    padding: 1px;\n                }');
        } catch ($p) {
          if ($p instanceof Error) {
            var e_1 = $p;
          } else {
            throw $p;
          }
        }
        try {
          this.hb1_1.xb1('progress.kui::-moz-progress-bar {\n                    height: 100%;\n                    background-color: currentColor;\n                    border-radius: 1rem;\n                }');
        } catch ($p) {
          if ($p instanceof Error) {
            var e_2 = $p;
          } else {
            throw $p;
          }
        }
        try {
          this.hb1_1.xb1('input.kui::-webkit-outer-spin-button, input.kui::-webkit-inner-spin-button {\n                    -webkit-appearance: none;\n                }');
        } catch ($p) {
          if ($p instanceof Error) {
            var e_3 = $p;
          } else {
            throw $p;
          }
        }
        try {
          this.hb1_1.xb1('input.kui[type=number] {\n                    -moz-appearance: textfield\n                }');
        } catch ($p) {
          if ($p instanceof Error) {
            var e_4 = $p;
          } else {
            throw $p;
          }
        }
        this.ib1_1 = HashSet().ha();
        var tmp_2 = this;
        // Inline function 'kotlin.time.Companion.seconds' call
        Companion_getInstance_0();
        tmp_2.jb1_1 = toDuration(0, DurationUnit_SECONDS_getInstance());
        this.kb1_1 = HashSet().ha();
        this.lb1_1 = HashSet().ha();
      }
      yb1(transition) {
        if (!this.ib1_1.v(transition.yax_1))
          return 'transition-' + transition.yax_1;
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().d1();
        this_0.wb('@keyframes transition-' + transition.yax_1 + '-enter { from { ');
        transition$extracted(this_0, transition.zax_1);
        var tmp$ret$2 = this_0.toString();
        this.hb1_1.zb1(tmp$ret$2, 0);
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_1 = StringBuilder().d1();
        this_1.wb('@keyframes transition-' + transition.yax_1 + '-exit { from { ');
        transition$extracted(this_1, transition.aay_1);
        var tmp$ret$5 = this_1.toString();
        this.hb1_1.zb1(tmp$ret$5, 0);
        return 'transition-' + transition.yax_1;
      }
      ab2(theme) {
        if (!this.kb1_1.v(theme.db0_1))
          return _get_classes__of2uz9(this, theme);
        // Inline function 'kotlin.time.measureTime' call
        // Inline function 'kotlin.time.measureTime' call
        var mark = Monotonic_instance.hj();
        var tmp0_safe_receiver = theme.ub0_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          this.ab2(tmp0_safe_receiver);
        }
        this.mb1(theme);
        var cs = _get_classSelector__lhiabq(this, theme);
        themeInteractive$_anonymous_$sub_69hfgi(theme, this, cs, null, listOf_0(''));
        themeInteractive$_anonymous_$sub_69hfgi(theme, this, cs, SelectedSemantic_getInstance(), listOf_0('.checked.checkResponsive'));
        themeInteractive$_anonymous_$sub_69hfgi(theme, this, cs, UnselectedSemantic_getInstance(), listOf_0('.checkResponsive'));
        var tmp$ret$4 = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
        // Inline function 'kotlin.also' call
        var this_0 = new (Duration())(tmp$ret$4);
        var it = this_0.nj_1;
        this.jb1_1 = Duration__plus_impl_yu9v8f(this.jb1_1, it);
        this_0.nj_1;
        this.hb1_1.oc();
        return _get_classes__of2uz9(this, theme);
      }
      nb1(theme, diff, asSelectors, includeMaybeTransition, mediaQuery) {
        var classes = _get_classes__of2uz9(this, theme);
        var directSel = theme$sel(asSelectors, ['.kui']);
        var backSel = includeMaybeTransition ? theme$sel(asSelectors, ['.kui.clickable']) : theme$sel(asSelectors, ['.kui.transition']);
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_0 = theme.ob0_1;
        var tmp;
        var tmp_0;
        if (diff == null) {
          tmp_0 = null;
        } else {
          tmp_0 = diff.ob0_1;
        }
        if (!equals(tmp_0, this_0)) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_safe_receiver = tmp;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp_1 = diff == null ? null : diff.ob0_1;
          if (tmp_1 instanceof FadingColor()) {
            theme$addToCss(this, mediaQuery, backSel, 'animation', 'none');
          }
          if (tmp0_safe_receiver instanceof Color()) {
            theme$addToCss(this, mediaQuery, backSel, 'background-color', tmp0_safe_receiver.paz());
            theme$addToCss(this, mediaQuery, backSel, 'background-image', 'none');
          } else {
            if (tmp0_safe_receiver instanceof FadingColor()) {
              this.hb1_1.xb1(trimIndent('\n                        @keyframes ' + theme.db0_1 + '-flickerAnimation {\n                        0% {\n                            background-color: ' + tmp0_safe_receiver.bb0_1.paz() + ';\n                        }\n                        50% {\n                            background-color: ' + tmp0_safe_receiver.cb0_1.paz() + ';\n                        }\n                        100% {\n                            background-color: ' + tmp0_safe_receiver.bb0_1.paz() + ';\n                        }\n                    }\n                    '));
              theme$addToCss(this, mediaQuery, backSel, 'animation', '2s infinite ' + theme.db0_1 + '-flickerAnimation');
              theme$addToCss(this, mediaQuery, backSel, 'background-color', tmp0_safe_receiver.bb0_1.paz());
              theme$addToCss(this, mediaQuery, backSel, 'background-image', 'none');
            } else {
              if (tmp0_safe_receiver instanceof LinearGradient()) {
                theme$addToCss(this, mediaQuery, backSel, 'background-color', tmp0_safe_receiver.bb2().paz());
                var tmp0 = tmp0_safe_receiver.naz_1;
                // Inline function 'com.lightningkite.kiteui.models.Angle.plus' call
                var other = Companion_getInstance_1().hb2_1;
                var tmp$ret$5 = _Angle___init__impl__g23q1m(_Angle___get_turns__impl__atdtw5(tmp0) + _Angle___get_turns__impl__atdtw5(other));
                theme$addToCss(this, mediaQuery, backSel, 'background-image', 'linear-gradient(' + _Angle___get_turns__impl__atdtw5(tmp$ret$5) + 'turn, ' + joinGradientStops(this, tmp0_safe_receiver.maz_1) + ')');
                theme$addToCss(this, mediaQuery, backSel, 'background-attachment', tmp0_safe_receiver.oaz_1 ? 'fixed' : 'unset');
              } else {
                if (tmp0_safe_receiver instanceof RadialGradient()) {
                  theme$addToCss(this, mediaQuery, backSel, 'background-color', tmp0_safe_receiver.bb2().paz());
                  theme$addToCss(this, mediaQuery, backSel, 'background-image', 'radial-gradient(circle at center, ' + joinGradientStops(this, tmp0_safe_receiver.daz_1) + ')');
                  theme$addToCss(this, mediaQuery, backSel, 'background-attachment', tmp0_safe_receiver.eaz_1 ? 'fixed' : 'unset');
                } else {
                  noWhenBranchMatchedException();
                }
              }
            }
          }
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_1 = new (Dimension())(theme.mb0_1);
        var tmp_2;
        var tmp_3;
        if (diff == null) {
          tmp_3 = null;
        } else {
          tmp_3 = new (Dimension())(diff.mb0_1);
        }
        if (!equals(tmp_3, this_1)) {
          tmp_2 = this_1;
        } else {
          tmp_2 = null;
        }
        var tmp_4 = tmp_2;
        var tmp1_safe_receiver = tmp_4 == null ? null : tmp_4.wb1_1;
        var tmp_5 = tmp1_safe_receiver;
        if ((tmp_5 == null ? null : new (Dimension())(tmp_5)) == null)
          null;
        else {
          var tmp_6 = tmp1_safe_receiver;
          // Inline function 'kotlin.let' call
          var it = (tmp_6 == null ? null : new (Dimension())(tmp_6)).wb1_1;
          theme$addToCss(this, mediaQuery, backSel, 'outline-width', _Dimension___get_value__impl__urhqzr(it).toString());
          theme$addToCss(this, mediaQuery, backSel, 'outline-style', !equals(it, get_px(0)) ? 'solid' : 'none');
          var tmp0_0 = times(it, -1);
          // Inline function 'com.lightningkite.kiteui.models.coerceAtLeast' call
          var other_0 = times(theme.ib0_1.lb2_1, -1);
          var tmp$ret$13 = maxOf(new (Dimension())(tmp0_0), new (Dimension())(other_0)).wb1_1;
          theme$addToCss(this, mediaQuery, backSel, 'outline-offset', _Dimension___get_value__impl__urhqzr(tmp$ret$13).toString());
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_2 = new (Dimension())(theme.fb0_1);
        var tmp_7;
        var tmp_8;
        if (diff == null) {
          tmp_8 = null;
        } else {
          tmp_8 = new (Dimension())(diff.fb0_1);
        }
        if (!equals(tmp_8, this_2)) {
          tmp_7 = this_2;
        } else {
          tmp_7 = null;
        }
        var tmp_9 = tmp_7;
        var tmp2_safe_receiver = tmp_9 == null ? null : tmp_9.wb1_1;
        var tmp_10 = tmp2_safe_receiver;
        if ((tmp_10 == null ? null : new (Dimension())(tmp_10)) == null)
          null;
        else {
          var tmp_11 = tmp2_safe_receiver;
          // Inline function 'kotlin.let' call
          (tmp_11 == null ? null : new (Dimension())(tmp_11)).wb1_1;
          theme$addToCss(this, mediaQuery, backSel, 'box-shadow', toBoxShadow(this, theme.fb0_1));
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_3 = new (Dimension())(theme.hb0_1);
        var tmp_12;
        var tmp_13;
        if (diff == null) {
          tmp_13 = null;
        } else {
          tmp_13 = new (Dimension())(diff.hb0_1);
        }
        if (!equals(tmp_13, this_3)) {
          tmp_12 = this_3;
        } else {
          tmp_12 = null;
        }
        var tmp_14 = tmp_12;
        var tmp3_safe_receiver = tmp_14 == null ? null : tmp_14.wb1_1;
        var tmp_15 = tmp3_safe_receiver;
        if ((tmp_15 == null ? null : new (Dimension())(tmp_15)) == null)
          null;
        else {
          var tmp_16 = tmp3_safe_receiver;
          // Inline function 'kotlin.let' call
          var it_0 = (tmp_16 == null ? null : new (Dimension())(tmp_16)).wb1_1;
          theme$addToCss(this, mediaQuery, directSel, '--spacing', _Dimension___get_value__impl__urhqzr(it_0).toString());
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_4 = theme.ib0_1;
        var tmp_17;
        var tmp_18;
        if (diff == null) {
          tmp_18 = null;
        } else {
          tmp_18 = diff.ib0_1;
        }
        if (!equals(tmp_18, this_4)) {
          tmp_17 = this_4;
        } else {
          tmp_17 = null;
        }
        var tmp4_safe_receiver = tmp_17;
        if (tmp4_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          theme$addToCss(this, mediaQuery, directSel, '--padding', this.ob2(tmp4_safe_receiver));
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_5 = new (Dimension())(theme.eb0_1.vb2_1);
        var tmp_19;
        var tmp_20;
        if (diff == null) {
          tmp_20 = null;
        } else {
          tmp_20 = new (Dimension())(diff.eb0_1.vb2_1);
        }
        if (!equals(tmp_20, this_5)) {
          tmp_19 = this_5;
        } else {
          tmp_19 = null;
        }
        var tmp_21 = tmp_19;
        var tmp5_safe_receiver = tmp_21 == null ? null : tmp_21.wb1_1;
        var tmp_22 = tmp5_safe_receiver;
        if ((tmp_22 == null ? null : new (Dimension())(tmp_22)) == null)
          null;
        else {
          var tmp_23 = tmp5_safe_receiver;
          // Inline function 'kotlin.let' call
          var it_1 = (tmp_23 == null ? null : new (Dimension())(tmp_23)).wb1_1;
          theme$addToCss(this, mediaQuery, directSel, 'font-size', _Dimension___get_value__impl__urhqzr(it_1).toString());
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_6 = theme.eb0_1.pb2_1;
        var tmp_24;
        var tmp_25;
        if (diff == null) {
          tmp_25 = null;
        } else {
          tmp_25 = diff.eb0_1.pb2_1;
        }
        if (!equals(tmp_25, this_6)) {
          tmp_24 = this_6;
        } else {
          tmp_24 = null;
        }
        var tmp6_safe_receiver = tmp_24;
        if (tmp6_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.let' call
          var tmp$ret$50 = this.hb1_1.yb2(tmp6_safe_receiver);
          theme$addToCss(this, mediaQuery, directSel, 'font-family', tmp$ret$50);
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_7 = theme.eb0_1.rb2_1;
        var tmp_26;
        var tmp_27;
        if (diff == null) {
          tmp_27 = null;
        } else {
          tmp_27 = diff.eb0_1.rb2_1;
        }
        if (!equals(tmp_27, this_7)) {
          tmp_26 = this_7;
        } else {
          tmp_26 = null;
        }
        var tmp7_safe_receiver = tmp_26;
        if (tmp7_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          theme$addToCss(this, mediaQuery, directSel, 'font-weight', tmp7_safe_receiver.toString());
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_8 = theme.eb0_1.qb2_1;
        var tmp_28;
        var tmp_29;
        if (diff == null) {
          tmp_29 = null;
        } else {
          tmp_29 = diff.eb0_1.qb2_1;
        }
        if (!equals(tmp_29, this_8)) {
          tmp_28 = this_8;
        } else {
          tmp_28 = null;
        }
        var tmp8_safe_receiver = tmp_28;
        if (tmp8_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.let' call
          var tmp$ret$66 = tmp8_safe_receiver ? 'italic' : 'normal';
          theme$addToCss(this, mediaQuery, directSel, 'font-style', tmp$ret$66);
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_9 = theme.eb0_1.sb2_1;
        var tmp_30;
        var tmp_31;
        if (diff == null) {
          tmp_31 = null;
        } else {
          tmp_31 = diff.eb0_1.sb2_1;
        }
        if (!equals(tmp_31, this_9)) {
          tmp_30 = this_9;
        } else {
          tmp_30 = null;
        }
        var tmp9_safe_receiver = tmp_30;
        if (tmp9_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.let' call
          var tmp$ret$75 = tmp9_safe_receiver ? 'uppercase' : 'none';
          theme$addToCss(this, mediaQuery, directSel, 'text-transform', tmp$ret$75);
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_10 = theme.eb0_1.tb2_1;
        var tmp_32;
        var tmp_33;
        if (diff == null) {
          tmp_33 = null;
        } else {
          tmp_33 = diff.eb0_1.tb2_1;
        }
        if (!equals(tmp_33, this_10)) {
          tmp_32 = this_10;
        } else {
          tmp_32 = null;
        }
        var tmp10_safe_receiver = tmp_32;
        if (tmp10_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          theme$addToCss(this, mediaQuery, directSel, 'line-height', tmp10_safe_receiver.toString());
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_11 = theme.eb0_1.wb2_1 && theme.eb0_1.xb2_1 ? 'underline line-through' : theme.eb0_1.wb2_1 ? 'line-through' : theme.eb0_1.xb2_1 ? 'underline' : 'none';
        var tmp_34;
        var tmp_35;
        if (diff == null) {
          tmp_35 = null;
        } else {
          tmp_35 = diff.eb0_1.wb2_1 && diff.eb0_1.xb2_1 ? 'underline line-through' : diff.eb0_1.wb2_1 ? 'line-through' : diff.eb0_1.xb2_1 ? 'underline' : 'none';
        }
        if (!equals(tmp_35, this_11)) {
          tmp_34 = this_11;
        } else {
          tmp_34 = null;
        }
        var tmp11_safe_receiver = tmp_34;
        if (tmp11_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          theme$addToCss(this, mediaQuery, directSel, 'text-decoration-line', tmp11_safe_receiver);
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_12 = theme.eb0_1.tb2_1;
        var tmp_36;
        var tmp_37;
        if (diff == null) {
          tmp_37 = null;
        } else {
          tmp_37 = diff.eb0_1.tb2_1;
        }
        if (!equals(tmp_37, this_12)) {
          tmp_36 = this_12;
        } else {
          tmp_36 = null;
        }
        var tmp12_safe_receiver = tmp_36;
        if (tmp12_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          theme$addToCss(this, mediaQuery, directSel, 'line-height', tmp12_safe_receiver.toString());
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_13 = new (Dimension())(theme.eb0_1.ub2_1);
        var tmp_38;
        var tmp_39;
        if (diff == null) {
          tmp_39 = null;
        } else {
          tmp_39 = new (Dimension())(diff.eb0_1.ub2_1);
        }
        if (!equals(tmp_39, this_13)) {
          tmp_38 = this_13;
        } else {
          tmp_38 = null;
        }
        var tmp_40 = tmp_38;
        var tmp13_safe_receiver = tmp_40 == null ? null : tmp_40.wb1_1;
        var tmp_41 = tmp13_safe_receiver;
        if ((tmp_41 == null ? null : new (Dimension())(tmp_41)) == null)
          null;
        else {
          var tmp_42 = tmp13_safe_receiver;
          // Inline function 'kotlin.let' call
          var it_2 = (tmp_42 == null ? null : new (Dimension())(tmp_42)).wb1_1;
          theme$addToCss(this, mediaQuery, directSel, 'letter-spacing', Dimension__toString_impl_o4q1ad(it_2));
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_14 = theme.lb0_1;
        var tmp_43;
        var tmp_44;
        if (diff == null) {
          tmp_44 = null;
        } else {
          tmp_44 = diff.lb0_1;
        }
        if (!equals(tmp_44, this_14)) {
          tmp_43 = this_14;
        } else {
          tmp_43 = null;
        }
        var tmp14_safe_receiver = tmp_43;
        if (tmp14_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          theme$addToCss(this, mediaQuery, directSel, 'outline-color', tmp14_safe_receiver.bb2().paz());
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_15 = new (Duration())(theme.tb0_1);
        var tmp_45;
        var tmp_46;
        if (diff == null) {
          tmp_46 = null;
        } else {
          tmp_46 = new (Duration())(diff.tb0_1);
        }
        if (!equals(tmp_46, this_15)) {
          tmp_45 = this_15;
        } else {
          tmp_45 = null;
        }
        var tmp_47 = tmp_45;
        var tmp15_safe_receiver = tmp_47 == null ? null : tmp_47.nj_1;
        var tmp_48 = tmp15_safe_receiver;
        if ((tmp_48 == null ? null : new (Duration())(tmp_48)) == null)
          null;
        else {
          var tmp_49 = tmp15_safe_receiver;
          // Inline function 'kotlin.let' call
          var it_3 = (tmp_49 == null ? null : new (Duration())(tmp_49)).nj_1;
          theme$addToCss(this, mediaQuery, directSel, 'transition-duration', toCss(this, it_3));
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_16 = new (Duration())(theme.tb0_1);
        var tmp_50;
        var tmp_51;
        if (diff == null) {
          tmp_51 = null;
        } else {
          tmp_51 = new (Duration())(diff.tb0_1);
        }
        if (!equals(tmp_51, this_16)) {
          tmp_50 = this_16;
        } else {
          tmp_50 = null;
        }
        var tmp_52 = tmp_50;
        var tmp16_safe_receiver = tmp_52 == null ? null : tmp_52.nj_1;
        var tmp_53 = tmp16_safe_receiver;
        if ((tmp_53 == null ? null : new (Duration())(tmp_53)) == null)
          null;
        else {
          var tmp_54 = tmp16_safe_receiver;
          // Inline function 'kotlin.let' call
          var it_4 = (tmp_54 == null ? null : new (Duration())(tmp_54)).nj_1;
          theme$addToCss(this, mediaQuery, directSel, '--transition-duration', toCss(this, it_4));
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_17 = theme.ob0_1;
        var tmp_55;
        var tmp_56;
        if (diff == null) {
          tmp_56 = null;
        } else {
          tmp_56 = diff.ob0_1;
        }
        if (!equals(tmp_56, this_17)) {
          tmp_55 = this_17;
        } else {
          tmp_55 = null;
        }
        var tmp17_safe_receiver = tmp_55;
        if (tmp17_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          theme$addToCss(this, mediaQuery, directSel, '--nearest-background-color', tmp17_safe_receiver.bb2().paz());
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_18 = theme.gb0_1;
        var tmp_57;
        var tmp_58;
        if (diff == null) {
          tmp_58 = null;
        } else {
          tmp_58 = diff.gb0_1;
        }
        if (!equals(tmp_58, this_18)) {
          tmp_57 = this_18;
        } else {
          tmp_57 = null;
        }
        var tmp18_safe_receiver = tmp_57;
        if (tmp18_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          theme$addToCss(this, mediaQuery, backSel, 'border-radius', toRawCornerRadius(tmp18_safe_receiver));
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_19 = new (Dimension())(theme.pb0_1);
        var tmp_59;
        var tmp_60;
        if (diff == null) {
          tmp_60 = null;
        } else {
          tmp_60 = new (Dimension())(diff.pb0_1);
        }
        if (!equals(tmp_60, this_19)) {
          tmp_59 = this_19;
        } else {
          tmp_59 = null;
        }
        var tmp_61 = tmp_59;
        var tmp19_safe_receiver = tmp_61 == null ? null : tmp_61.wb1_1;
        var tmp_62 = tmp19_safe_receiver;
        if ((tmp_62 == null ? null : new (Dimension())(tmp_62)) == null)
          null;
        else {
          var tmp_63 = tmp19_safe_receiver;
          // Inline function 'kotlin.let' call
          var it_5 = (tmp_63 == null ? null : new (Dimension())(tmp_63)).wb1_1;
          if (!_Dimension___get_value__impl__urhqzr(it_5).equals(Companion_getInstance().nax_1)) {
            var filterValue = 'blur(' + _Dimension___get_value__impl__urhqzr(it_5).toString() + ')';
            // Inline function 'kotlin.text.isNotEmpty' call
            if (charSequenceLength(filterValue) > 0) {
              theme$addToCss(this, mediaQuery, backSel, 'backdrop-filter', filterValue);
              theme$addToCss(this, mediaQuery, backSel, '-webkit-backdrop-filter', filterValue);
            } else {
              theme$addToCss(this, mediaQuery, backSel, 'backdrop-filter', 'none');
              theme$addToCss(this, mediaQuery, backSel, '-webkit-backdrop-filter', 'none');
            }
          } else {
            theme$addToCss(this, mediaQuery, backSel, 'backdrop-filter', 'none');
            theme$addToCss(this, mediaQuery, backSel, '-webkit-backdrop-filter', 'none');
          }
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_20 = theme.jb0_1;
        var tmp_64;
        var tmp_65;
        if (diff == null) {
          tmp_65 = null;
        } else {
          tmp_65 = diff.jb0_1;
        }
        if (!equals(tmp_65, this_20)) {
          tmp_64 = this_20;
        } else {
          tmp_64 = null;
        }
        var tmp20_safe_receiver = tmp_64;
        if (tmp20_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          theme$addToCss(this, mediaQuery, directSel, 'color-scheme', tmp20_safe_receiver.bb2().zb2() > 0.5 ? 'dark' : 'light');
          if (tmp20_safe_receiver instanceof Color()) {
            theme$addToCss(this, mediaQuery, directSel, 'color', tmp20_safe_receiver.paz());
          } else {
            if (tmp20_safe_receiver instanceof FadingColor()) {
              theme$addToCss(this, mediaQuery, directSel, 'color', tmp20_safe_receiver.bb0_1.paz());
            } else {
              if (tmp20_safe_receiver instanceof LinearGradient()) {
                var tmp0_1 = tmp20_safe_receiver.naz_1;
                // Inline function 'com.lightningkite.kiteui.models.Angle.plus' call
                var other_1 = Companion_getInstance_1().hb2_1;
                var tmp$ret$154 = _Angle___init__impl__g23q1m(_Angle___get_turns__impl__atdtw5(tmp0_1) + _Angle___get_turns__impl__atdtw5(other_1));
                theme$addToCss(this, mediaQuery, directSel, 'color', 'linear-gradient(' + _Angle___get_turns__impl__atdtw5(tmp$ret$154) + 'turn, ' + joinGradientStops(this, tmp20_safe_receiver.maz_1) + ')');
                var tmp0_2 = tmp20_safe_receiver.naz_1;
                // Inline function 'com.lightningkite.kiteui.models.Angle.plus' call
                var other_2 = Companion_getInstance_1().hb2_1;
                var tmp$ret$155 = _Angle___init__impl__g23q1m(_Angle___get_turns__impl__atdtw5(tmp0_2) + _Angle___get_turns__impl__atdtw5(other_2));
                theme$addToCss(this, mediaQuery, directSel, 'background', '-webkit-linear-gradient(' + _Angle___get_turns__impl__atdtw5(tmp$ret$155) + 'turn, ' + joinGradientStops(this, tmp20_safe_receiver.maz_1) + ')');
                theme$addToCss(this, mediaQuery, directSel, '-webkit-background-clip', 'text');
                theme$addToCss(this, mediaQuery, directSel, '-webkit-text-fill-color', 'transparent');
              } else {
                if (tmp20_safe_receiver instanceof RadialGradient()) {
                  theme$addToCss(this, mediaQuery, directSel, 'color', 'radial-gradient(circle at center, ' + joinGradientStops(this, tmp20_safe_receiver.daz_1) + ')');
                  theme$addToCss(this, mediaQuery, directSel, 'background', '-webkit-radial-gradient(circle at center, ' + joinGradientStops(this, tmp20_safe_receiver.daz_1) + ')');
                  theme$addToCss(this, mediaQuery, directSel, '-webkit-background-clip', 'text');
                  theme$addToCss(this, mediaQuery, directSel, '-webkit-text-fill-color', 'transparent');
                } else {
                  noWhenBranchMatchedException();
                }
              }
            }
          }
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_21 = theme.ab3();
        var tmp_66;
        var tmp_67;
        if (diff == null) {
          tmp_67 = null;
        } else {
          tmp_67 = diff.ab3();
        }
        if (!equals(tmp_67, this_21)) {
          tmp_66 = this_21;
        } else {
          tmp_66 = null;
        }
        var tmp21_safe_receiver = tmp_66;
        if (tmp21_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          if (tmp21_safe_receiver instanceof Color()) {
            theme$addToCss(this, mediaQuery, directSel, '--icon-color', tmp21_safe_receiver.paz());
          } else {
            if (tmp21_safe_receiver instanceof FadingColor()) {
              theme$addToCss(this, mediaQuery, directSel, '--icon-color', '');
            } else {
              theme$addToCss(this, mediaQuery, directSel, '--icon-color', tmp21_safe_receiver.bb2().paz());
            }
          }
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_22 = theme.bb3();
        var tmp_68;
        var tmp_69;
        if (diff == null) {
          tmp_69 = null;
        } else {
          tmp_69 = diff.bb3();
        }
        if (!equals(tmp_69, this_22)) {
          tmp_68 = this_22;
        } else {
          tmp_68 = null;
        }
        var tmp22_safe_receiver = tmp_68;
        if (tmp22_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          if (tmp22_safe_receiver instanceof Color()) {
            theme$addToCss(this, mediaQuery, directSel, '--separator-color', tmp22_safe_receiver.paz());
          } else {
            if (tmp22_safe_receiver instanceof FadingColor()) {
              theme$addToCss(this, mediaQuery, directSel, '--separator-color', '');
            } else {
              theme$addToCss(this, mediaQuery, directSel, '--separator-color', tmp22_safe_receiver.bb2().paz());
            }
          }
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_23 = theme.qb0_1;
        var tmp_70;
        var tmp_71;
        if (diff == null) {
          tmp_71 = null;
        } else {
          tmp_71 = diff.qb0_1;
        }
        if (!equals(tmp_71, this_23)) {
          tmp_70 = this_23;
        } else {
          tmp_70 = null;
        }
        var tmp23_safe_receiver = tmp_70;
        if (tmp23_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          if (!(tmp23_safe_receiver == null)) {
            // Inline function 'kotlin.collections.mutableListOf' call
            var transformParts = ArrayList().w();
            if (!(tmp23_safe_receiver.cb3_1 === 0.0) || !(tmp23_safe_receiver.db3_1 === 0.0) || !(tmp23_safe_receiver.eb3_1 === 0.0)) {
              // Inline function 'kotlin.collections.mutableListOf' call
              var translateParts = ArrayList().w();
              if (!(tmp23_safe_receiver.cb3_1 === 0.0)) {
                translateParts.v('' + tmp23_safe_receiver.cb3_1 + 'px');
              }
              if (!(tmp23_safe_receiver.db3_1 === 0.0)) {
                translateParts.v('' + tmp23_safe_receiver.db3_1 + 'px');
              }
              if (!(tmp23_safe_receiver.eb3_1 === 0.0)) {
                translateParts.v('' + tmp23_safe_receiver.eb3_1 + 'px');
              }
              transformParts.v('translate3d(' + joinToString(translateParts, ', ') + ')');
            }
            if (!(tmp23_safe_receiver.hb3_1 === 0.0)) {
              transformParts.v('rotate(' + tmp23_safe_receiver.hb3_1 + 'deg)');
            }
            if (!(tmp23_safe_receiver.fb3_1 === 0.0)) {
              transformParts.v('rotateX(' + tmp23_safe_receiver.fb3_1 + 'deg)');
            }
            if (!(tmp23_safe_receiver.gb3_1 === 0.0)) {
              transformParts.v('rotateY(' + tmp23_safe_receiver.gb3_1 + 'deg)');
            }
            if (!(tmp23_safe_receiver.ib3_1 === 1.0) || !(tmp23_safe_receiver.jb3_1 === 1.0)) {
              transformParts.v('scale(' + tmp23_safe_receiver.ib3_1 + ', ' + tmp23_safe_receiver.jb3_1 + ')');
            }
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!transformParts.i1()) {
              theme$addToCss(this, mediaQuery, backSel, 'transform', joinToString(transformParts, ' '));
            }
          } else {
            theme$addToCss(this, mediaQuery, backSel, 'transform', 'none');
          }
        }
        return classes;
      }
      mb1(theme, diff, asSelectors, includeMaybeTransition, mediaQuery, $super) {
        diff = diff === VOID ? null : diff;
        asSelectors = asSelectors === VOID ? listOf_0(_get_classSelector__lhiabq(this, theme)) : asSelectors;
        includeMaybeTransition = includeMaybeTransition === VOID ? false : includeMaybeTransition;
        mediaQuery = mediaQuery === VOID ? '' : mediaQuery;
        return $super === VOID ? this.nb1(theme, diff, asSelectors, includeMaybeTransition, mediaQuery) : $super.nb1.call(this, theme, diff, asSelectors, includeMaybeTransition, mediaQuery);
      }
      ob2(_this__u8e3s4) {
        return _Dimension___get_value__impl__urhqzr(_this__u8e3s4.lb2_1).toString() + ' ' + _Dimension___get_value__impl__urhqzr(_this__u8e3s4.mb2_1).toString() + ' ' + _Dimension___get_value__impl__urhqzr(_this__u8e3s4.nb2_1).toString() + ' ' + _Dimension___get_value__impl__urhqzr(_this__u8e3s4.kb2_1).toString();
      }
      kb3(breakpoints) {
        var name = 'rowCollapsingToColumn_' + joinToString(breakpoints, '_', VOID, VOID, VOID, VOID, KiteUiCss$rowCollapsingToColumn$lambda);
        if (this.lb1_1.v(name)) {
          this.hb1_1.xb1('\n                .' + name + '.rowCollapsing { display: flex }\n            ');
          // Inline function 'kotlin.collections.forEach' call
          var progression = numberRangeToNumber(-1, breakpoints.p1() - 1 | 0);
          var inductionVariable = progression.i2_1;
          var last = progression.j2_1;
          if (inductionVariable <= last)
            do {
              var element = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var index = element;
              var tmp = getOrNull(breakpoints, index);
              var tmp0_safe_receiver = tmp == null ? null : tmp.wb1_1;
              var tmp_0;
              var tmp_1 = tmp0_safe_receiver;
              if ((tmp_1 == null ? null : new (Dimension())(tmp_1)) == null) {
                tmp_0 = null;
              } else {
                var tmp_2 = tmp0_safe_receiver;
                // Inline function 'kotlin.let' call
                var it = (tmp_2 == null ? null : new (Dimension())(tmp_2)).wb1_1;
                tmp_0 = '(min-width: ' + _Dimension___get_value__impl__urhqzr(it).toString() + ')';
              }
              var tmp_3 = tmp_0;
              var tmp_4 = getOrNull(breakpoints, index + 1 | 0);
              var tmp1_safe_receiver = tmp_4 == null ? null : tmp_4.wb1_1;
              var tmp_5;
              var tmp_6 = tmp1_safe_receiver;
              if ((tmp_6 == null ? null : new (Dimension())(tmp_6)) == null) {
                tmp_5 = null;
              } else {
                var tmp_7 = tmp1_safe_receiver;
                // Inline function 'kotlin.let' call
                var it_0 = (tmp_7 == null ? null : new (Dimension())(tmp_7)).wb1_1;
                tmp_5 = '(max-width: ' + _Dimension___get_value__impl__urhqzr(it_0).toString() + ')';
              }
              var mediaQuery = joinToString(listOfNotNull([tmp_3, tmp_5]), ' and ');
              if (((index + 2 | 0) % 2 | 0) === 1) {
                this.hb1_1.xb1(trimIndent('\n                    @media ' + mediaQuery + ' {\n                        .' + name + '.rowCollapsing {\n                            flex-direction: column;\n                        }\n                        .' + name + '.rowCollapsing > * {\n                            flex-grow: 0 !important;\n                            flex-shrink: 0 !important;\n                            flex-basis: auto !important;\n                        }\n                        .' + name + '.rowCollapsing > .hStart {\n                            align-self: start;\n                        }\n                        .' + name + '.rowCollapsing > .hCenter {\n                            align-self: center;\n                        }\n                        .' + name + '.rowCollapsing > .hStretch {\n                            align-self: stretch;\n                        }\n                        .' + name + '.rowCollapsing > .hEnd {\n                            align-self: end;\n                        }\n                    }\n                '));
              } else {
                this.hb1_1.xb1(trimIndent('\n                    @media ' + mediaQuery + ' {\n                        .' + name + '.rowCollapsing {\n                            flex-direction: row;\n                        }\n                        .' + name + '.rowCollapsing > .vStart {\n                            align-self: start;\n                        }\n                        .' + name + '.rowCollapsing > .vCenter {\n                            align-self: center;\n                        }\n                        .' + name + '.rowCollapsing > .vStretch {\n                            align-self: stretch;\n                        }\n                        .' + name + '.rowCollapsing > .vEnd {\n                            align-self: end;\n                        }\n                    }\n                '));
              }
            }
             while (!(element === last));
        }
        return name;
      }
    }
    initMetadataForClass($, 'KiteUiCss');
    KiteUiCssClass = $;
  }
  return KiteUiCssClass;
}
//region block: exports
export {
  KiteUiCss as KiteUiCsshhimfofutzw8,
};
//endregion

//# sourceMappingURL=KiteUiCss.mjs.map
